import {
	LockKey,
	Phone,
	ShieldCheck,
	MapPin,
	ShoppingCart,
	PaperPlaneRight,
	Plus,
} from "@phosphor-icons/react";
import { Iphone } from "@/components/ui/iphone";

export function Trust() {
	return (
		<section
			id="trust"
			className="py-24 lg:py-32 bg-slate-900 text-white relative overflow-hidden px-4"
		>
			{/* Background */}
			<div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary via-slate-900 to-slate-900" />
			<svg
				className="absolute bottom-0 right-0 w-96 h-96 text-white/5 translate-x-1/3 translate-y-1/3"
				viewBox="0 0 100 100"
				fill="currentColor"
			>
				<path d="M43.1,89.5c-15.4,3.3-31-6.6-34.3-22c-3.3-15.4,6.6-31,22-34.3c15.4-3.3,31,6.6,34.3,22C68.4,70.6,58.5,86.2,43.1,89.5z M47.8,40.1c-10.4-2.2-20.9,4.4-23.1,14.8c-2.2,10.4,4.4,20.9,14.8,23.1c10.4,2.2,20.9-4.4,23.1-14.8C64.9,52.8,58.3,42.3,47.8,40.1z" />
			</svg>

			<div className="max-w-7xl mx-auto relative z-10">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
					{/* Phone Mockup */}
					<div className="relative order-2 lg:order-1 flex justify-center">
						<div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full" />
						<div className="relative w-full max-w-xs -rotate-2 hover:rotate-0 transition-transform duration-500">
							<Iphone>
								<div className="size-full flex flex-col bg-white text-dark">
									{/* Chat Header */}
									<div className="bg-surface px-4 py-3 border-b border-gray-100 flex items-center justify-between">
										<div className="flex items-center gap-2.5">
											<div className="w-9 h-9 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden shrink-0">
												<img
													src="https://i.pravatar.cc/150?img=12"
													alt="Runner avatar"
													className="w-full h-full object-cover"
												/>
											</div>
											<div>
												<p className="text-sm font-bold leading-tight">
													Emeka A.
												</p>
												<p className="text-xs text-secondary font-medium leading-tight">
													Verified Runner
												</p>
											</div>
										</div>
										<div className="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center">
											<Phone size={16} weight="fill" />
										</div>
									</div>

									{/* Errand Summary Card */}
									<div className="mx-3 mt-3 bg-info rounded-xl p-3">
										<div className="flex items-center gap-2 mb-2">
											<div className="w-6 h-6 rounded-lg bg-primary/10 flex items-center justify-center">
												<ShoppingCart
													size={13}
													weight="fill"
													className="text-primary"
												/>
											</div>
											<span className="text-xs font-bold text-primary">
												Groceries from Shoprite Lekki
											</span>
										</div>
										<div className="flex items-start gap-1.5 ml-1">
											<MapPin
												size={12}
												weight="fill"
												className="text-secondary shrink-0 mt-0.5"
											/>
											<p className="text-xs text-secondary leading-snug">
												Shoprite, The Palms Mall &rarr; Ajah
											</p>
										</div>
									</div>

									{/* Chat Messages */}
									<div className="flex-1 px-3 py-3 flex flex-col gap-2.5 bg-gray-50 overflow-hidden">
										{/* Runner message */}
										<div className="bg-white text-sm leading-relaxed p-3 rounded-2xl rounded-tl-sm border border-gray-100 self-start shadow-sm max-w-[85%]">
											I'm at Shoprite now. They don't have 10kg Mama Gold, only
											5kg bags. Should I get two?
										</div>

										{/* Customer reply */}
										<div className="bg-primary text-white text-sm leading-relaxed p-3 rounded-2xl rounded-tr-sm self-end shadow-sm max-w-[85%]">
											Yes please! Also grab the freshest tomatoes you can find
										</div>

										{/* Runner message */}
										<div className="bg-white text-sm leading-relaxed p-3 rounded-2xl rounded-tl-sm border border-gray-100 self-start shadow-sm max-w-[85%]">
											Got it. Peppers look great today too, should I add some?
										</div>

										{/* Customer reply */}
										<div className="bg-primary text-white text-sm leading-relaxed p-3 rounded-2xl rounded-tr-sm self-end shadow-sm max-w-[85%]">
											Yes! A bag of the fresh ones
										</div>

										{/* Runner message */}
										<div className="bg-white text-sm leading-relaxed p-3 rounded-2xl rounded-tl-sm border border-gray-100 self-start shadow-sm max-w-[85%]">
											Heading to checkout now, total is &#8358;18,200
										</div>
									</div>

									{/* Escrow Status Bar */}
									<div className="bg-white border-t border-gray-100 px-3 py-2">
										<div className="flex items-center justify-between bg-secondary/5 border border-secondary/20 rounded-xl px-3 py-2">
											<div className="flex items-center gap-2">
												<ShieldCheck
													size={14}
													weight="fill"
													className="text-secondary"
												/>
												<span className="text-xs font-bold text-secondary">
													&#8358;25,000 in escrow
												</span>
											</div>
											<span className="text-xs font-bold text-secondary bg-secondary/10 px-2 py-0.5 rounded-md">
												Locked
											</span>
										</div>
									</div>

									{/* Message Input */}
									<div className="bg-white border-t border-gray-100 px-3 py-2 pb-3 flex items-center gap-2">
										<button
											type="button"
											className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center shrink-0"
										>
											<Plus
												size={16}
												weight="bold"
												className="text-secondary"
											/>
										</button>
										<div className="flex-1 bg-gray-100 rounded-full px-4 py-2 text-sm text-slate">
											Type a message...
										</div>
										<button
											type="button"
											className="w-8 h-8 rounded-full bg-primary flex items-center justify-center shrink-0"
										>
											<PaperPlaneRight
												size={14}
												weight="fill"
												className="text-white"
											/>
										</button>
									</div>
								</div>
							</Iphone>

							{/* Floating Badge */}
							<div className="absolute -right-4 top-1/4 bg-white text-dark rounded-2xl p-3 shadow-xl border border-gray-100 rotate-3 animate-float-delayed z-20">
								<div className="flex items-center gap-2.5">
									<div className="w-8 h-8 rounded-full bg-green-100 text-green-600 flex items-center justify-center">
										<ShieldCheck size={16} weight="fill" />
									</div>
									<div>
										<p className="text-xs font-bold">100% Secure</p>
										<p className="text-[10px] text-slate">Funds protected</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Text Content */}
					<div className="order-1 lg:order-2">
						<p className="text-secondary font-bold tracking-widest uppercase text-sm mb-4 flex items-center gap-2">
							<LockKey size={16} weight="fill" /> Safety First
						</p>
						<h2 className="text-3xl md:text-4xl font-extrabold mb-6">
							No one gets burned. <br />
							<span className="font-script text-secondary text-4xl md:text-5xl font-normal">
								That's a promise.
							</span>
						</h2>
						<p className="text-lg text-slate-300 mb-10 leading-relaxed">
							Proxi is built so you never hand a stranger cash upfront. Escrow
							locks your money in a secure hold, and the runner only gets paid
							when you confirm the job is actually done.
						</p>

						{/* Steps */}
						<div className="space-y-8">
							<div className="flex gap-4">
								<div className="w-12 h-12 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-white font-bold text-xl shrink-0">
									1
								</div>
								<div>
									<h3 className="text-xl font-bold mb-2">
										Lock the funds in escrow
									</h3>
									<p className="text-slate-400 leading-relaxed">
										Once you and a runner agree on a price, the money moves from
										your wallet into a secure hold. Not the runner's pocket. Not
										ours. Not even for a second.
									</p>
								</div>
							</div>

							<div className="flex gap-4">
								<div className="w-12 h-12 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-white font-bold text-xl shrink-0">
									2
								</div>
								<div>
									<h3 className="text-xl font-bold mb-2">
										Chat and coordinate
									</h3>
									<p className="text-slate-400 leading-relaxed">
										Message, call, and share photos from inside the app. Your
										phone number, home address, and WhatsApp stay private the
										whole way through.
									</p>
								</div>
							</div>

							<div className="flex gap-4">
								<div className="w-12 h-12 rounded-full bg-secondary border border-secondary flex items-center justify-center text-white font-bold text-xl shrink-0 shadow-glow-primary">
									3
								</div>
								<div>
									<h3 className="text-xl font-bold mb-2 text-secondary">
										Confirm and release
									</h3>
									<p className="text-slate-400 leading-relaxed">
										When the errand arrives as promised, share a one-time code.
										The runner gets paid. Any change — say, ₦4,800 back from a
										smaller grocery bill — lands in your wallet automatically.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
